import { useQuery } from "@tanstack/react-query"
import { trpcClient } from "@tokenterminal/core/utils/trpc"

interface PoweredByProject {
  data_id: string
  slug: string
  name: string
  logo: string
}

export function usePoweredByProjects(poweredByDataIds: string[] = []) {
  // Fetch and filter projects in a single query with proper cache key
  const {
    data: poweredByProjects = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["powered-by-projects", poweredByDataIds],
    queryFn: async () => {
      if (poweredByDataIds.length === 0) return []

      const allProjects = await trpcClient.projects.getProjects.query()

      return (
        (allProjects.data?.filter((project: any) =>
          poweredByDataIds.includes(project.data_id)
        ) as PoweredByProject[]) || []
      )
    },
    enabled: poweredByDataIds.length > 0,
  })

  return {
    data: poweredByProjects,
    isLoading,
    error,
  }
}
